'use client'

import {createContext} from 'react'

const HeaderContext = createContext({
	isDark: false,
	setIsDark: null,
})

export default HeaderContext
